var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48.58 0C21.793 0 0 21.793 0 48.58s21.793 48.58 48.58 48.58 48.58-21.793 48.58-48.58S75.367 0 48.58 0zm0 10.338c21.087 0 38.244 17.154 38.244 38.242 0 21.088-17.157 38.242-38.244 38.242S10.336 69.668 10.336 48.58c0-21.088 17.157-38.242 38.244-38.242zm-.514 6.492a4 4 0 0 0-4 4v30.25a4 4 0 0 0 4 4h25.832a4 4 0 0 0 0-8H52.066V20.83a4 4 0 0 0-4-4z"}));
}

Clock.defaultProps = {"viewBox":"0 0 97.16 97.16"};

module.exports = Clock;

Clock.default = Clock;
